'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _prep2.default)({
    name: 'delete',
    immutable: 'delete',
    record: 'delete',
    object: function object(key) {
        return function (value) {
            var clone = _extends({}, value);
            delete clone[key];
            return clone;
        };
    },
    array: function array(key) {
        return function (value) {
            var clone = [].concat(_toConsumableArray(value));
            clone.splice(key, 1);
            return clone;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/delete.js
// module id = 155
// module chunks = 35783957827783